<template>
    <div id="app">
        <router-view v-if="$route.name === '404' || $route.name === 'Авторизация' || $route.name === 'Панель' || $route.name === 'Регистрация партнера'"></router-view>
        <div id="wrapper" v-else>
            <ul class="navbar-nav bg-gradient-primary sidebar sidebar-dark accordion" id="accordionSidebar">
                <!-- Sidebar - Brand -->
                <a class="sidebar-brand d-flex align-items-center justify-content-center" href="index.html">
                    <div class="sidebar-brand-icon rotate-n-15">
                        <img src="@/assets/logo.png" alt="Tech 8" height="40">
                    </div>
                    <div class="sidebar-brand-text mx-3">Tech <sup>8</sup></div>
                </a>

                <!-- Divider -->
                <hr class="sidebar-divider my-0">

                <!-- Nav Item - Dashboard -->
                <li :class="$route.path === link.to ? 'nav-item active': 'nav-item'" v-for="(link, index) in links" :key="index" v-if="profile.subdomain === 'tech8' && link.name === 'WhatsApp' || profile.subdomain !== 'tech8'">
                    <router-link class="nav-link" :to="link.to">
                        <i :class="link.class"></i>
                        <span>{{link.name}}</span></router-link>
                </li>

            </ul>
            <div id="content-wrapper" class="d-flex flex-column">
                <div id="content">
                    <nav class="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">

                        <!-- Topbar Navbar -->
                        <ul class="navbar-nav ml-auto">

                            <div class="topbar-divider d-none d-sm-block"></div>
                            <li class="nav-item dropdown no-arrow">
                                <a class="nav-link dropdown-toggle" href="#" id="userDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    <span class="mr-2 d-none d-lg-inline text-gray-600 small">{{$store.state.profile.login}}</span>
                                </a>
                                <div class="dropdown-menu dropdown-menu-right shadow animated--grow-in" aria-labelledby="userDropdown">
                                    <a href="#" class="dropdown-item" @click="logout">
                                        <i class="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400"></i>
                                        Выйти
                                    </a>
                                </div>
                            </li>

                        </ul>

                    </nav>
                    <router-view></router-view>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery'
export default {
  name: 'app',
  data () {
    return {
      class: 'none',
      links: [
        {
          'to': '/cabinet',
          'name': 'Монитор',
          'class': 'fas fa-fw fa-tachometer-alt'
        },
        {
          'to': '/widgets',
          'name': 'Виджеты',
          'class': 'fas fa-fw fa-cogs'
        },
        {
          'to': '/clients',
          'name': 'Клиенты',
          'class': 'fas fa-fw fa-users'
        },
        {
          'to': '/cash',
          'name': 'Клиенты с панели',
          'class': 'fas fa-fw fa-dollar-sign'
        },
        {
          'to': '/whatsapp',
          'name': 'WhatsApp',
          'class': 'fab fa-whatsapp'
        },
        {
          'to': '/whatsappl',
          'name': 'WhatsApp LOG',
          'class': 'fab fa-whatsapp'
        },
        {
          'to': '/telegram',
          'name': 'Telegram',
          'class': 'fab fa-telegram-plane'
        },
        {
          'to': '/promo',
          'name': 'Партнеры',
          'class': 'fas fa-users'
        }
      ]
    }
  },
  computed: {
    profile () {
      return this.$store.getters.getProfile
    }
  },
  mounted () {
    if (this.$route.path !== '/') $('body').addClass('show_absolute')
    else $('body').removeClass('show_absolute')
  },
  methods: {
    logout: function () {
      this.$store.dispatch('AUTH_LOGOUT')
        .then(() => {
          this.$router.push('/login')
        })
    }
  },
  watch: {
    $route (to, from) {
      if (to.path !== '/') $('body').addClass('show_absolute')
      else $('body').removeClass('show_absolute')
    }

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/app.vue